import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=5ff7856d&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
import style0 from "./Logs.vue?vue&type=style&index=0&id=5ff7856d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7856d",
  null
  
)

export default component.exports